<template>
  <div>
    <Header></Header>
    <div class="cpal1">
      <img class="cpalA1" src="@/assets/cpal.png" alt="" />
      <div class="cpalB1">产品案例 - 智慧工地</div>
      <div class="cpalC1">SMART CONSTRUCTION SITE</div>
    </div>
    <div class="body">
      <div>
        <div class="cpszh">智慧工地</div>
        <div class="bodyTitle">
          <div class="product">SMART CONSTRUCTION SITE</div>
          <!-- <div class="more">
            <div class="datetime">2022-10-23</div>
          </div> -->
        </div>
      </div>
      <div class="bodyContent">
        <div>
          <img class="cpalb1" src="@/assets/智慧工地.png" alt="" />
          <img class="cpalb1" src="@/assets/智慧工地2.png" alt="" />
        </div>
        <div class="fontA11">
          &emsp;&emsp;运用信息化手段，通过三维设计平台对工程项目进行精确设计和施工模拟，围绕施工过程管理，建立互联协同、智能生产、科学管理的施工项目信息化生态圈，并将此数据在虚拟现实环境下与物联网采集到的工程信息进行数据挖掘分析，提供过程趋势预测及专家预案，实现工程施工可视化智能管理，以提高工程管理信息化水平，从而逐步实现绿色建造和生态建造。
        </div>
      </div>
      <div class="LastNext">
        <div class="last" @click="fourL">上一案例：{{ last }}</div>
        <div class="next" @click="fourN">下一案例：{{ next }}</div>
      </div>
    </div>
    <Footer></Footer>
  </div>
</template>

<script>
import Header from "@/views/header.vue";
import Footer from "@/views/footer.vue";
export default {
  components: {
    Header,
    Footer,
  },
  data() {
    return {
      last: "智慧执法运输",
      next: "智慧水利",
    };
  },
  methods: {
    fourL() {
        this.$router.push({ name: "productCase3" });
    },
    fourN() {
        this.$router.push({ name: "productCase5" });
    }
  },
};
</script>

<style scoped>
* {
  margin: 0;
  padding: 0;
}
.lbt {
  width: 100%;
}
.body {
  width: 1200px;
  margin: 0 auto;
  padding-bottom: 80px;
  background: #fff !important;
}
.cpszh {
  font-size: 24px;
  padding: 40px 0 4px 32px;
  color: #183f85;
  letter-spacing: 1px;
}
.bodyTitle {
  display: flex;
  justify-content: space-between;
  margin-right: 32px;
}
.product {
  font-size: 24px;
  color: #bfbfbf;
  margin-left: 32px;
  letter-spacing: 1px;
}
.more {
  display: flex;
}
.datetime {
  font-size: 20px;
  color: #7d7d7d;
  letter-spacing: 1px;
}
.bodyContent {
  display: block;
  border-bottom: 1px solid #d8d8d8;
}
.cpalb1 {
    width: 100%;
  margin: 24px 32px;
}
.fontA1 {
  font-size: 20px;
  letter-spacing: 1px;
  margin: 0 24px 0 32px;
  line-height: 40px;
}
.fontA11 {
  font-size: 20px;
  letter-spacing: 1px;
  margin: 0 24px 46px 32px;
  line-height: 40px;
}
.LastNext {
  display: flex;
  justify-content: space-between;
  margin-top: 24px;
  font-size: 20px;
  color: #7d7d7d;
  letter-spacing: 1px;
}
.last {
    cursor: pointer;
}
.next {
    cursor: pointer;
}
.cpal1 {
  position: relative;
}
.cpalA1 {
  width: 100%;
}
.cpalB1 {
  position: absolute;
  top: 200px;
  transform: translate(-50%);
  left: 50%;
  width: 1200px;
  margin-left: 32px;
  font-size: 60px;
  color: #fff;
  line-height: 33px;
  letter-spacing: 1px;
}
.cpalC1 {
  position: absolute;
  top: 280px;
  transform: translate(-50%);
  left: 50%;
  width: 1200px;
  margin-left: 32px;
  font-size: 24px;
  color: #bfbfbf;
  line-height: 33px;
  letter-spacing: 1px;
}
</style>
